import { refType } from "@mui/utils";
import axios from "axios";
import { GetMetodo, GetValores, getVerTienda, LimpiarDescuentoVenta } from "./CarritoLocalStorang";
import { Host, token } from "./constantes";
import { clienteInfo, getDatosUsuariosLocalStorag } from "./DatosUsuarioLocalStorag";
import { BuscarTransacion } from "./pagos/Queripagos";
import { GeneraComprobante, logWithCallback } from "utilsstile.js/style";
import { datosCompraMeta, metaInfoPago, metaOrdenRegistrada, vigilarPagoCompra } from "./metaPixel";
import { ofrecerPush } from "./pushNotificaciones";
/** reportar Pago */
export const PagoRapido = async (transaccion, opciones = {}) => {
    let codigoEvento = sessionStorage.getItem('eventoid')
    let randon = sessionStorage.getItem("random");
    let Eventoinfo = JSON.parse(sessionStorage.getItem('infoevento'))
    let codicontry = sessionStorage.getItem("codicontry") ? sessionStorage.getItem("codicontry") : false
    let asientos = sessionStorage.getItem("asientosList") != null
        ? JSON.parse(sessionStorage.getItem("asientosList"))
            .map(e => e.ids ?? e.idsilla ?? e.id_silla ?? null)
            .filter(e => e != null)
        : []
    let array = sessionStorage.getItem("sillascorre") != null ? JSON.parse(sessionStorage.getItem("sillascorre")) : []
    let tiktefisic = sessionStorage.getItem("ticktesfisio") != null ? JSON.parse(sessionStorage.getItem("ticktesfisio")) : []
    let datosPersonal = getDatosUsuariosLocalStorag().cedula
    let discapacidad = getDatosUsuariosLocalStorag().discapacidad
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let metodo = GetMetodo() == "Transferencia" ? "Deposito" : GetMetodo()
    const requiereAprobacionManual = metodo == "Deposito"
    //let tienda= getVerTienda();
    let canal = "Web";
    if (esMovil()) {
        canal = "Web Movil";
    }
    // Deuna solo devuelve QR (canal "Web") o link (cualquier otro canal), nunca los
    // dos -- permite que quien llama elija explicitamente cual pedir (ver el
    // selector de "Código QR" / "Link para copiar" en ModalPago.js), en vez de
    // depender siempre de la deteccion de dispositivo de arriba.
    if (opciones.canalOverride) {
        canal = opciones.canalOverride
    }
    let cantidadTotal = getVerTienda().reduce((total, concierto) => {
        return total + concierto.cantidad;
    }, 0);
    let sillas = [...asientos, ...array]
    //  si discrimino lo tengo que guardar  let total = GetMetodo() == "Tarjeta" ? parseFloat(GetValores().total) : parseFloat(GetValores().comision) + parseFloat(GetValores().subtotal)
    void cantidadTotal; void sillas; // Mantenido por compatibilidad con otros usos futuros
    // Si el metodo elegido no cobra comision de boleteria (GetValores ya la
    // deja en 0, ver aplicaComisionBoletoParaMetodo), info_concierto tampoco
    // debe llevarla -- si no, el detalle de la compra muestra una comision
    // que nunca se cobro.
    const cobraComisionBoleto = parseFloat(GetValores().comision) > 0
    let concierto = getVerTienda().map((e) => {
        const factorBoletos = Number(e?.localidaEspacio?.factor_boletos || e?.factor_boletos || 1)
        const factorSeguro = Number.isFinite(factorBoletos) && factorBoletos > 1 ? factorBoletos : 1
        const cantidadAsientos = Number(e?.cantidad || 0)
        const cantidadPaquetes = factorSeguro > 1 ? Math.ceil(cantidadAsientos / factorSeguro) : cantidadAsientos
        // Opcion de compra elegida (Individual / promocion de la localidad); si no, la de siempre segun el factor
        const opcionElegida = e?.localidaEspacio?.modalidad_elegida && e.localidaEspacio.modalidad_elegida !== "INDIVIDUAL"
            ? e.localidaEspacio.modalidad_codigo : ""
        const modalidadCodigo = e?.modalidad_codigo || opcionElegida || (factorSeguro > 1 ? "DOUBLE" : "SIMPLE")
        // Para correlativo: las sillas de este item están en sillascorre, filtramos solo las necesarias
        // Para sillas normales: tomar del array asientos filtrado por localidad
        const idLocalidadItem = String(e.localidaEspacio["idcolor"] || e.localidaEspacio["id_localidad"] || "")
        const esTipoCorrelativo = String(e.localidaEspacio["typo"] || "").toLowerCase() === "correlativo"
        let idSillasItem = []
        if (esTipoCorrelativo) {
            // sillascorre contiene los IDs de las sillas correlativas reservadas para este usuario
            idSillasItem = array.slice(0, cantidadAsientos)
        } else {
            idSillasItem = asientos
                .filter(s => s != null)
                .slice(0, cantidadAsientos)
        }
        return {
            "nombreConcierto": Eventoinfo.nombreConcierto,
            "id_localidad": e.localidaEspacio["idcolor"] || e.localidaEspacio["id_localidad"],
            "idespaciolocalida": e.localidaEspacio["ideprecio"] || e.localidaEspacio["ideprecio"],
            "CODIGEVENTO": codigoEvento,
            "cantidad": e.cantidad,
            "cantidad_paquetes": cantidadPaquetes,
            "factor_boletos": factorSeguro,
            "modalidad_codigo": modalidadCodigo,
            "localidad_nombre": e.localidad || e.localidaEspacio["nombre"],
            "localidad_precio": (discapacidad == 'Si' && parseFloat(e.localidaEspacio["precio_discapacidad"] || 0) > 0)
                ? parseFloat(e.localidaEspacio["precio_discapacidad"])
                : parseFloat(e.valor),
            "discapacida": (discapacidad == 'Si' && parseFloat(e.localidaEspacio["precio_discapacidad"] || 0) > 0),
            "pointOfSale":'',
            menor: (parseInt(e.localidaEspacio["idcolor"]) == 308),
            naipes: getDatosUsuariosLocalStorag().naipes ? (getDatosUsuariosLocalStorag().naipes == 'Si') : null,
            "comision_por_boleto": cobraComisionBoleto ? parseInt(e.cantidad) * parseFloat(e.localidaEspacio["comision_boleto"]) : 0,
            "id_sillas": idSillasItem.length === cantidadAsientos ? idSillasItem : [],
            "iva": Eventoinfo.iva,
            "post": Eventoinfo.post ? Eventoinfo.post : ""
        }
    })
    let datos = {
        "cedula": datosPersonal,
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
        "nombreCompleto": getDatosUsuariosLocalStorag().nombreCompleto ?? '',
        // En depositos/transferencias se evita el correo inicial para que el envio ocurra solo tras aprobacion manual.
        "email": requiereAprobacionManual ? "" : (getDatosUsuariosLocalStorag().email ?? ''),
        "forma_pago": metodo,
        "canal": canal,
        "pointOfSale":'',
        "concierto": [...concierto],
        "valores": {
            "total": parseFloat(GetValores().total),
            "comision": parseFloat(GetValores().comision),
            "subtotal": parseFloat(GetValores().subtotal),
            "comision_bancaria": parseFloat(GetValores().comision_bancaria),
            "description": GetValores().description,
            "iva": GetValores().iva
        },
        "random": randon,
        "codigo_boletos": [...tiktefisic],
        "idfactura": "",
        "transaccion": transaccion,
        "canjear": opciones.canjear === true,
        "enviar_correo": opciones.enviarCorreo === true,
    }

    // Tarjeta física (POS en mano): número de lote y referencia del
    // voucher -- obligatorios para este método, el backend también los
    // exige/valida (máximo 6 dígitos cada uno).
    if (metodo === "Tarjeta-Local") {
        datos.tarjeta_lote = opciones.tarjetaLote || ""
        datos.tarjeta_referencia = opciones.tarjetaReferencia || ""
    }

    // Descuento (%) de ESTA venta. Se deja en sessionStorage porque
    // PagoRapido arma TODO el payload desde ahi. El backend revalida y
    // recalcula total_pago.
    //   { id }     -> descuento que marco un vendedor en ModalPago
    //   { codigo } -> descuento por link publico (?desc=CODIGO en la tienda)
    try {
        const descSel = JSON.parse(sessionStorage.getItem("descuentoVentaSel") || "null")
        if (descSel && descSel.codigo) datos.descuento = { codigo: String(descSel.codigo) }
        else if (descSel && descSel.id) datos.descuento = { id: descSel.id }
    } catch (_e) { /* sin descuento */ }

    if (requiereAprobacionManual) {
        datos.estado = "Comprobar"
        datos.estado_pago = "Comprobar"
        datos.enviar_correo = false
        datos.generar_ticket = false
        datos.send_email = false
        datos.notify = false
        datos.notificar = false
        datos.enviar_ticket = false
        datos.email = "pending.aprobacion@no-mail.local"
    }

    // Pixel de Meta: datos para que el backend informe la compra cuando quede pagada, y el aviso de que
    // eligio metodo de pago. Solo compras del propio cliente con permiso de cookies (si no, no manda nada).
    try {
        // con el concierto: si tiene su propio pixel (Ajustes > Pixeles por concierto) tambien cuenta
        const meta = await datosCompraMeta(Eventoinfo && Eventoinfo.codigoEvento)
        if (meta) {
            datos.meta = meta
            metaInfoPago(metodo, datos.valores && datos.valores.total, Eventoinfo)
        }
    } catch (_e) { /* el pixel nunca frena la compra */ }

    try {

        logWithCallback(datos)

        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/registraCompra ", datos, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        }
        )

        logWithCallback(data)
        // El backend rechazo el descuento (cedula que ya lo uso, tope de usos,
        // caducado...): se quita de la sesion para que el siguiente intento
        // se calcule y se cobre sin descuento.
        if (data && data.descuento_invalido) {
            LimpiarDescuentoVenta()
            return { ...data, id: data.idRegistro, ...datos };
        }
        // La compra ya se registro con su descuento: se limpia para que no
        // se arrastre a la siguiente venta (Modalefectivo/ModalReporte no lo
        // limpiaban; ModalPago si, en cada camino exitoso).
        if (data && data.success) LimpiarDescuentoVenta()
        // Pixeles: orden registrada (TikTok del concierto). Solo si hubo permiso de cookies (datos.meta). Nunca frena.
        if (data && data.success && datos.meta) {
            try { metaOrdenRegistrada(Eventoinfo, datos.valores && datos.valores.total, data.idRegistro) } catch (_e) { }
            // Si se paga mientras el cliente sigue en la pagina, se avisa la compra pagada a los pixeles
            try { vigilarPagoCompra({ idCompra: data.idRegistro, cedula: datos.cedula, total: datos.valores && datos.valores.total, evento: Eventoinfo }) } catch (_e) { }
        }
        // Avisos push: se le ofrece "avisarme cuando mis boletos esten listos" (no en ventas del panel; nunca frena la compra)
        if (data && data.success && clienteInfo() == null) {
            try { setTimeout(() => ofrecerPush({ motivo: "compra", idCompra: data.idRegistro, cedula: datos.cedula, codigoEvento: Eventoinfo && (Eventoinfo.codigoEvento || Eventoinfo.codigo) }), 2500) } catch (_e) { }
        }
        clienteInfo() != null ? GeneraComprobante(datos) : ""
        return { ...data, id: data.idRegistro, ...datos };
        // await EnviarDetalleCompra(email, parm)

    } catch (error) {
        console.log(error)
        return error

    }

}
function esMovil() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
/** OCRAPI */
export const OCRApi = async (parms) => {
    try {
        const urlImagen = parms?.url_imagen || parms?.url
        const requestId = String(parms?.request_id || Date.now())
        let { data } = await axios.post("https://api.t-ickets.com/mikroti/Boleteria/imagenocr/analizar", {
            "url_imagen": urlImagen,
            "request_id": requestId,
            "guardar_bd": Boolean(parms?.guardar_bd)
        })

        const dataOCR = data?.data || {}
        const numeroDocumento = dataOCR?.numero_comprobante || dataOCR?.referencia || null
        const dataNormalizada = {
            ...dataOCR,
            numero_documento: numeroDocumento,
            banco: dataOCR?.banco_receptor || dataOCR?.banco_emisor || null,
            beneficiario: dataOCR?.nombre_receptor || null,
            fecha: dataOCR?.fecha || null
        }

        // Detección de duplicado: marca para revisión manual pero permite el registro
        let esDuplicado = false;
        if (numeroDocumento) {
            let datos = await BuscarTransacion({
                "numeroTransaccion": numeroDocumento
            })
            // Las compras anuladas no cuentan (el backend devuelve cuantas compras activas lo tienen)
            if (datos?.success && (datos.activas === undefined || Number(datos.activas) > 0)) {
                esDuplicado = true;
                // En lugar de rechazar, marca para revisión manual pero permite registrar
            }
        }

        logWithCallback(data)
        return {
            ...data,
            success: Boolean(data?.estado),
            duplicado: esDuplicado,
            message: esDuplicado 
                ? "Comprobante duplicado detectado - se enviará a revisión manual"
                : (data?.estado ? "OCR procesado correctamente" : (dataOCR?.observaciones || "No se pudo validar el comprobante")),
            data: { ...dataNormalizada, duplicado: esDuplicado }
        }
    } catch (error) {
        return error
    }
}

/** Listar todos los reportes de tickes */
export const AprobarTiket = async () => {
    try {
        let { data } = await axios.get("https://api.t-ickets.com/ms_login/ticket_admin", {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
/**  */
export const ConsolidaBoleto = async () => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/boletos", {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const Contactos_Boletos = async (parmas) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/mikroti/Boleteria/Contactos", {
            "evento": parmas
        }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const cederboleto = async (ceder) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        ...ceder,
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/ceder_boleto", parmspro, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
    } catch (error) {
    }
}

export const GeneraToken = async (parms) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/generar_token", parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (err) {
        return err
    }
}
export const ValidarToken = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id": parms,
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/confirmarpago", {
            ...parmspro
        }
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
                }
            })
        return data
    } catch (error) {
        return error
    }
}
export const generaTiketspdf = async (parms) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ticket/api/v1/ticket_pdf_link", parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const generaTiketsBingo = async (parms, id) => {
    try {
        let { data } = await axios.put("https://api.t-ickets.com/mikroti/Boleteria/bingo/" + id, parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
//verificar pago tarjeta 
export const CambiarPagoTC = async (parms) => {
    try {
        let { data } = await axios.post("", parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error

    }
}

//https://api.t-ickets.com/ms_login/doc/static/index.html#/Compra/post_api_v1_liverar_asiento
//https://api.t-ickets.com/ms_login/doc/static/index.html#/Compra/post_api_v1_generarBoleto     

/* "Banco Guayaquil / App" (recaudacion por COMNET): consulta si ya se pago la factura de la compra y, si se
   pago, el backend la confirma al instante (ademas el backend la revisa solo cada pocos minutos). */
export const VerificarPagoRecaudacion = async (idRegistro) => {
    const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/recaudacion/verificar", { idRegistro: Number(idRegistro) }, {
        headers: {
            'Content-Type': 'application/json',
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
        }
    })
    return data
}
